import createModel from './lib/create_model';

const Narvar = createModel({
  modelName: 'Narvar',

  properties: {
    leftLabel: String,
    leftContent: String,
    rightLabel: String,
    rightContent: String,
    url: String,
    urlLabel: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default Narvar;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/narvar.js